export class Recapture {
    public ReleasedICES: string;
    public ReleasedYear: number;
    public ReleasedLongitude: number;
    public ReleasedLatitude: number;
    public RecapturedTime: string;
    public RecapturedTimestamp: Date;
    public RecapturedYear: number;
    public RecapturedFactoryId: string;
    public RecapturedFactory: string;
    public RecapturedArea: any;
    public RecapturedExpedition : string;
}